import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, isRef as _isRef } from "vue"

const _hoisted_1 = { class: "multilingual-box" }

import { ref, computed, watch, onMounted } from 'vue';
import { dubbingGetLanguages } from '@/request/multilingual';
import { emitter } from '@/utils/events';
import { useDictsStore } from '@/pinia';
import { InfoFilled } from '@element-plus/icons-vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'multilingual',
  props: {
  vModelTtsType: {
    type: String,
    default: '',
  },
  vModelTargetLang: {
    type: String,
    default: '',
  },
  vModelSexType: {
    type: [Number, String],
    default: '',
  },
},
  emits: ['update:vModelTtsType', 'update:vModelSexType', 'update:vModelTargetLang', 'typeChange'],
  setup(__props, { emit: __emit }) {

const dictsStore = useDictsStore();

const emits = __emit;
const props = __props;

let targetLang = ref([]);
let form = ref({});

let vModelSexType = computed({
  get() {
    return props.vModelSexType;
  },
  set(value) {
    emits('update:vModelSexType', value);
  },
});
let vModelTtsType = computed({
  get() {
    return props.vModelTtsType || 'chinese';
  },
  set(value) {
    emits('update:vModelTtsType', value);
  },
});

let vModelTargetLang = computed({
  get() {
    return props.vModelTargetLang;
  },
  set(value) {
    emits('update:vModelTargetLang', value);
  },
});

const newOptions = ref([]);

let dicOptions = ref({
  seamless: [],
  elevenlabs: [],
});

function extractValues(obj) {
  if (!obj || obj.value === undefined) {
    return [];
  }

  return [obj.value].concat(
    Array.isArray(obj.children) && obj.children.length > 0
      ? extractValues(obj.children[0])
      : []
  );
}

const options = [
  {
    value: 'chinese',
    label: '中文版',
    dubbingMode: '',
    sex: false,
  },
  {
    value: 'seamless',
    label: '普通版',
    dubbingMode: 'seamless',
    sex: true,
    equityKey: 'SCYP_DYZ_SEAMLESS_XK'
  },
  {
    value: 'elevenlabs',
    label: '高级版',
    dubbingMode: 'elevenlabs',
    sex: false,
    equityKey: 'SCYP_DYZ_ELEVENLABS_XK'
  },
];

let multilingualArr = computed(() => {
  if (newOptions.value?.length && vModelTtsType.value && vModelTtsType.value !== 'chinese') {
    let { children } = newOptions.value.find((v) => v.value === vModelTtsType.value);
    return children;
  } else return [];
});

function addGenderChildren() {
  return [
    { value: 1, label: '男' },
    { value: 0, label: '女' },
  ];
}

function addChildrenWithOptions(options, dubbingMode, childrenValues) {
  return options.map((option) => {
    if (option.dubbingMode === dubbingMode) {
      let children = childrenValues.map((item) => {
        const child = { value: item.value, label: item.name };
        if (option.sex) {
          child.children = addGenderChildren();
        }
        return child;
      });
      return { ...option, children };
    }
    return option;
  });
}

watch(
  () => targetLang.value,
  (arr) => {
    if (arr?.length) {
      vModelTargetLang.value = arr[0];
      vModelSexType.value = vModelTtsType.value == 'seamless' ? arr[1] : '';
    } else {
      vModelTtsType.value = '';
      vModelTargetLang.value = '';
      vModelSexType.value = '';
    }
  }
);

async function updateOptions(dubbingMode) {
  try {
    const updatedOptions = addChildrenWithOptions(options, dubbingMode, [...dictsStore.dicts[dubbingMode]]);
    newOptions.value = [...newOptions.value, ...updatedOptions.filter((option) => option.dubbingMode === dubbingMode)];
    dicOptions.value[dubbingMode] = [updatedOptions.find((v) => v.value === dubbingMode)];
  } catch (error) {
    console.error('Error fetching languages:', error);
  }
}

updateOptions('seamless');
updateOptions('elevenlabs');

onMounted(() => {
  emitter.on('multilingual', ({ ttsType = '', targetLang: datilTargetLang = '', sexType = '' }) => {
    vModelTtsType.value = ttsType;
    let arr = [datilTargetLang, sexType];
    if (ttsType === 'elevenlabs') {
      targetLang.value = [arr[0]]
    } else targetLang.value = ttsType ? arr : []
  });
})

let changeTtsTypeFn = (key) => {
  if (dicOptions.value[key]) {
    let arr = extractValues(dicOptions.value[key].find(Boolean));
    let arrSlice = arr.slice(1);
    targetLang.value = arrSlice
  } else targetLang.value = []

  emits('typeChange');
}

let clearFn = () => {
  vModelTtsType.value = ''  //发现残余bug
  emits('typeChange');
}

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_cascader = _resolveComponent("el-cascader")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      size: "small",
      model: _unref(form),
      "label-width": "auto",
      style: {"width":"100%"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, { label: "多语言版本:" }, {
          label: _withCtx(() => [
            _createElementVNode("span", null, [
              _cache[2] || (_cache[2] = _createTextVNode("多语言版本: ")),
              _createVNode(_component_el_tooltip, {
                effect: "dark",
                content: "高级版多语言需合成视频后才生效",
                placement: "top"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_icon, { style: {"color":"#e6a23c"} }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(InfoFilled))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              size: "small",
              modelValue: _unref(vModelTtsType),
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(vModelTtsType) ? (vModelTtsType).value = $event : vModelTtsType = $event)),
              onChange: _unref(changeTtsTypeFn),
              placeholder: "请先选择多语言版本"
            }, {
              default: _withCtx(() => [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(options, (i) => {
                  return _createVNode(_component_el_option, {
                    label: i.label,
                    value: i.value,
                    key: i.value
                  }, null, 8, ["label", "value"])
                }), 64))
              ]),
              _: 1
            }, 8, ["modelValue", "onChange"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "语言类型" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_cascader, {
              class: "cascader",
              modelValue: _unref(targetLang),
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(targetLang) ? (targetLang).value = $event : targetLang = $event)),
              options: _unref(multilingualArr),
              placeholder: "可选择语言类型",
              size: "small",
              clearable: "",
              onClear: _unref(clearFn)
            }, null, 8, ["modelValue", "options", "onClear"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model"])
  ]))
}
}

})